import React from 'react';
import styles from './NmsTradePage.module.scss';
import DataGrid, { Column, ColumnChooser, StateStoring, Scrolling, Sorting } from 'devextreme-react/data-grid';
import classNames from 'classnames';
import { TableFooter } from '../../components/TableFooter';
import { Tooltip } from 'devextreme-react/tooltip';
import { HeadTitle } from '../../components/HeadTitle';
import { Header } from '../../components/Header';
import { NmsTradeFilter } from '../NmsTradeFilter';
import { getNmsTrades, downloadNmsTrades } from '../../api/nmsTrade';
import { Loading } from '../../components/Loading';
import { formatTradeDate, formatQty, formatPrice } from '../../util/tradeDataRenderFunctions';

const initialState = {
  queryParam: {},
  title: 'NMS Trade',
  isLoaded: false,
  isReloading: false,
  data: {},
  error: null,
  sort: {
    sortOn: '',
    sortDir: 'asc'
  }
};
var loadingOptions = {
  enabled: false
};

class NmsTradePage extends React.Component {
  constructor (props) {
    super(props);
    this.dataGridRef = React.createRef();
    let collapseOnSearch = window.localStorage.getItem('tps_collapseSearch') === 'true';
    this.state = {

      ...initialState,
      startDateUpdate: '',
      endDateUpdate: '',
      mpidUpdate: '',
      isDownloadInactive: false,
      isSearching: false,
      columnChooserTooltip: false,
      collapseOnSearch: collapseOnSearch

    };
    this.baseState = this.state;

    this.loadData = this.loadData.bind(this);

    this.setQueryParameters = this.setQueryParameters.bind(this);
    this.handleErrorResults = this.handleErrorResults.bind(this);
    this.clear = this.clear.bind(this);
    this.download = this.download.bind(this);
    this.showColumnChooserOptions = this.showColumnChooserOptions.bind(this);
    this.handleCellClickChange = this.handleCellClickChange.bind(this);
    this.addMenuItems = this.addMenuItems.bind(this);
  }

  showColumnChooserOptions () {
    if (this.dataGrid) {
      this.dataGrid.showColumnChooser();
    }
  }

  toggleColumnChooserTooltip = () => {
    this.setState({
      columnChooserTooltip: !this.state.columnChooserTooltip
    });
  }

  get dataGrid () {
    var gridRef;
    if (this.dataGridRef && this.dataGridRef.current) {
      gridRef = this.dataGridRef.current.instance;
    }
    return gridRef;
  }

  setQueryParameters (queryParamObj, type) {
    const isDownload = type === 'download';
    if (isDownload) {
      this.setState({ queryParam: queryParamObj }, this.download);
    } else {
      this.clear();
      // start the loading icon
      this.setState({ isSearching: true, hasMoreError: null });
      // get only specific trades
      this.setState({ queryParam: queryParamObj }, this.loadData);
    }
  }

  loadData () {
    var filters = this.state.queryParam;
    var sort = this.state.sort;
    getNmsTrades(filters, sort)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          hasMoreError: data.hasMoreError,
          data: data
        }));
      })
      .catch((error) => {
        // error
        console.log(error);
        var message = (error && error.response &&
          error.response.data && error.response.data) || 'Data currently unavailable';
        this.handleErrorResults(message);
      });
  }

  clear () {
    // just reset the data and not other config
    this.setState(this.baseState);
  }

  download () {
    if (this.state.isDownloadInactive) return;
    // make it inactive for future request until current one is solved
    this.setState({ isDownloadInactive: true });
    // download trade data
    var filters = this.state.queryParam;
    downloadNmsTrades(filters).then(data => {
      this.setState({ isDownloadInactive: false });
    })
      .catch((err) => {
        // error
        this.setState({ isDownloadInactive: false });
        console.log(err);
      });
  }

  // handle sorting
  handleCellClickChange (e) {
    //  (e.column.dataField);

    if (e.rowType === 'header' && e.column.allowSorting) {
      var newSortField = e.column.dataField;
      var currentSortField = this.state.sort.sortOn;
      var currentSortDir = this.state.sort.sortDir;
      // assume its new field,there fore direction would be asc
      var sortDir = 'asc';
      if (newSortField === currentSortField && currentSortDir === 'asc') {
        sortDir = 'desc';
      }

      // this.dataGrid.columnOption(currentSortField, 'sortOrder', void 0);
      // this.dataGrid.columnOption(newSortField, 'sortOrder', sortDir);
      this.setState(prevState => ({
        isReloading: true,
        sort: {
          sortOn: newSortField,
          sortDir: sortDir
        }

      }), this.loadData);
    }
  }

  handleErrorResults (errorMessage) {
    this.setState(prevState => ({
      isLoaded: true,
      isReloading: false,
      data: {},
      hasMoreError: null,
      sort: {
        sortOn: '',
        sortDir: 'asc'
      },
      error: errorMessage
    }));
  }

  addMenuItems (e) {
    //  console.log(e.column.dataField);
    if (e.column && e.row && e.column.dataField === 'mpid' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];

      // Add a custom menu item
      e.items.push({
        text: 'Add to Mpid',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            mpidUpdate: e.row.data.mpid
          });
        }
      });
    } else if (e.column && e.row && e.column.dataField === 'tradeDate' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];
      let value = e.row.data.tradeDate;
      // Add a custom menu item
      e.items.push({
        text: 'Add to Start Date',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            startDateUpdate: value
          });
        }
      });
      e.items.push({
        text: 'Add to End Date',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            endDateUpdate: value
          });
        }
      });
    }
  }

  render () {
    const data = this.state.data;
    const isDataLoaded = this.state.isLoaded && data && data.results && data.results.length > 0;
    return (
      <div>
        <HeadTitle title={this.state.title} />
        <Header title={this.state.title} />
        <NmsTradeFilter search={this.setQueryParameters}
          mpidUpdate={this.state.mpidUpdate}
          startDateUpdate={this.state.startDateUpdate}
          endDateUpdate={this.state.endDateUpdate}
          isDownloadInactive={this.state.isDownloadInactive}
          isDataLoaded={isDataLoaded}

        />

        {this.state.hasMoreError && this.state.hasMoreError !== '' &&
        <div className={styles.warning}>{this.state.hasMoreError}</div>}

        {this.state.isSearching && <Loading
          type='table'
          data={data.results}
          loaded={this.state.isLoaded}
          reloading={this.state.isReloading}
          error={this.state.error}
          emptyMessage='No results found.' >

          <div>
            <div className={styles.tableMenu}>
              <i
                id='column-chooser'
                className={classNames(styles.columnChooser, 'dx-icon-columnchooser')}
                onClick={this.showColumnChooserOptions}
                onMouseEnter={this.toggleColumnChooserTooltip}
                onMouseLeave={this.toggleColumnChooserTooltip}
              />
              <Tooltip
                target={'#column-chooser'}
                position='left'
                visible={this.state.columnChooserTooltip}
                hideOnOutsideClick={false}
              > Open Column Chooser</Tooltip>
            </div>
            <DataGrid
              id='nmsTradesGridContainer'
              className={classNames(styles.gridContainer, {
                [styles.collapseGrid]: this.state.collapseOnSearch
              })}
              ref={this.dataGridRef}
              dataSource={data.results}
              allowColumnReordering
              hoverStateEnabled
              columnAutoWidth
              rowAlternationEnabled
              showBorders
              repaintChangesOnly
              loadPanel={loadingOptions}
              onContextMenuPreparing={this.addMenuItems}
              onCellClick={this.handleCellClickChange}
            >
              <Scrolling mode='infinite' rowRenderingMode='virtual' />
              <Sorting mode='none' />
              <Column dataField='tradeDate' caption='Date' calculateDisplayValue={formatTradeDate} />
              <Column dataField='tradeTime' caption='Entered' />
              <Column dataField='venue' caption='Venue' />
              <Column dataField='mpid' caption='MPID' />
              <Column dataField='security' caption='Symbol' />
              <Column dataField='tradeSide' caption='Side' />
              <Column dataField='execQty' caption='Exec Qty' dataType='number' alignment='right' customizeText={formatQty} />
              <Column dataField='execPrice' caption='Price' dataType='number' alignment='right' customizeText={formatPrice} />
              <Column dataField='notional' allowSorting={false} caption='Notional' alignment='right' />
              <Column dataField='liquidityIndicator' caption='Liq Ind' allowSorting={false} />
              <Column dataField='orderCapacity' caption='Ord Capacity' allowSorting={false} visible={false} />
              <Column dataField='execId' caption='Exec ID' allowSorting={false} visible={false} />
              <Column dataField='exchangeRef' caption='Ex Ref' allowSorting={false} visible={false} />
              <Column dataField='userId' caption='User ID' allowSorting={false} visible={false} />

              <Column dataField='clientOrderId' caption='Cl Ord ID' allowSorting={false} visible={false} />
              <Column dataField='broker' caption='Contra Bkr' allowSorting={false} visible={false} />

              <ColumnChooser enabled allowSearch mode='select' title='Select Column(s)' />
              <StateStoring enabled type='localStorage' storageKey='userNmsTradeColumns' savingTimeout={10} />

            </DataGrid>
            <TableFooter totalResults={data && data.results && data.results.length} />

          </div>
        </Loading>
        }
      </div>
    );
  }
}
export default NmsTradePage;
